
export interface FilterOption {
  key: string;
  label: string;
}

export interface FilterSummaryItem {
  label: string;
  value: string;
}

export const buildSummary = (
  label: string,
  key: string,
  options: FilterOption[]
): FilterSummaryItem | null => {
  if (!key) {
    return null;
  }

  const match = options.find((option) => option.key === key);
  if (!match) {
    return null;
  }

  return { label, value: match.label };
};
